import React from "react"
import { View, StyleSheet, Text, ScrollView, Dimensions, Image, TouchableOpacity } from "react-native"
import { IconButton } from "react-native-paper"
import { Button } from "@Components/CustomButton/Button"
import { ContainerGlogal } from "@Components/ContainerGlogal"
import reinitialisation from "@assets/icons/reinitialisation.png"
import { BreeSerifText } from "@Components/CustomText/BreeSerifText"
import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { baseColors } from "@Constants/baseStyles"
import { MaterialCommunityIcons } from "@expo/vector-icons"

const { height, width } = Dimensions.get("screen")
export const MailSentPage = ({ navigation }) => {
    const backToLogin = () => {
        navigation.navigate("Login")
    }

    return (
        <ContainerGlogal>
            <ScrollView contentContainerStyle={{ paddingBottom: 50 }}>
                {/* <IconButton
                    rippleColor={"rgba(0,0,0,0.05)"}
                    onPress={() => backToLogin()}
                    icon="close"
                    color={baseColors.green.primary}
                    size={35}
                    style={{ alignSelf: "flex-end", marginRight: 20 }}
                /> */}

                <TouchableOpacity onPress={() => backToLogin()} style={{ alignSelf: "flex-end", padding: 20 }}>
                    <MaterialCommunityIcons name={"close"} size={35} color={baseColors.green.primary} />
                </TouchableOpacity>

                <Image
                    style={{ alignSelf: "center", marginTop: height / 7, height: 104 }}
                    resizeMode={"contain"}
                    source={reinitialisation}
                    defaultSource={reinitialisation}
                />
                <View style={[styles.container, { marginTop: 0 }]}>
                    <BreeSerifText textAlign={"center"} fontSize={22}>
                        Vérifier votre boîte mail !
                    </BreeSerifText>
                    <OpenSansText fontSize={16} textAlign={"center"} style={{ marginTop: 20 }}>
                        Nous vous avons envoyé un email avec les instructions pour réinitialiser votre mot de passe.
                    </OpenSansText>

                    <Button
                        text="Ouvrir mes mails"
                        width="80%"
                        backgroundColor={baseColors.green.primary}
                        labelColor={"white"}
                    />
                    <View style={{ marginTop: height / 5 }}>
                        <OpenSansText
                            textAlign={"center"}
                            color={baseColors.green.primary}
                            fontSize={16}
                            fontWeight={"bold"}
                        >
                            Vous n’avez pas reçu d’email ?
                        </OpenSansText>
                        <OpenSansText
                            style={{ textDecorationLine: "underline" }}
                            textAlign={"center"}
                            color={baseColors.green.primary}
                            fontSize={16}
                            fontWeight={"bold"}
                        >
                            Vérifiez vos spams ou contactez-nous !
                        </OpenSansText>
                    </View>
                </View>
            </ScrollView>
        </ContainerGlogal>
    )
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        paddingTop: 20,
        paddingHorizontal: 20,
        backgroundColor: "white",
        alignContent: "center"
    },
    text: {
        color: baseColors.black,
        textAlign: "justify",
        fontFamily: "BreeSerif",
        fontSize: 16
    }
})
